import React, { useEffect, useCallback, useState } from 'react';
import { DataList } from '../../../components';
import { paths } from '../../../routes';
import { useResidences } from '../../../hooks/theme.hook';
import { ReportStatus } from '../../../types';
import { useApi, useAuth } from '../../../hooks';
import Badge from '@material-ui/core/Badge';

export const SafetyList: React.FC = () => {
  const { residenceOptions } = useResidences();
  const [managers, setManagers] = useState<any>([]);
  const { auth } = useAuth();
  const [role = ''] = auth?.roles || [];
  const { getManagerList } = useApi();
  const getManagers = useCallback(async () => {
    try {
      const managers = await getManagerList();
      setManagers(managers);
    } catch (error) {
      console.log('get anomalies error', error);
    }
  }, [getManagerList]);
  useEffect(() => {
    getManagers();
  }, [getManagers]);
  const object = {
    circulationStartDate: {
      label: 'Date de circulation du',
      type: 'date',
      maxDateField: 'circulationEndDate',
      grid: 3,
    },
    circulationEndDate: {
      label: 'AU',
      type: 'date',
      minDateField: 'circulationStartDate',
      grid: 3,
    },
    userCPCode: {
      label: 'Numéro de CP',
      type: 'text',
      grid: 3,
    },
    residenceShortCode: {
      label: 'Résidence',
      type: 'select',
      name: 'residence',
      options: residenceOptions,
      grid: 3,
    },
    serviceName: {
      label: 'Numéro du train',
      type: 'text',
      grid: 3,
    },
    reportId: {
      label: 'Numéro du rapport',
      type: 'text',
      grid: 3,
    },
    reportStatus: {
      label: 'Statut du rapport',
      type: 'select',
      name: 'reportStatus',
      options: [
        {
          label: 'Enregistré',
          value: ReportStatus.saved,
        },
        {
          label: 'Envoyé',
          value: ReportStatus.sent,
        },
      ],
      grid: 3,
    },
    authorCPCode: {
      label: 'Managers',
      type: 'select',
      name: 'manager',
      options: managers.map((x: any) => {
        return {
          label: x.firstName + ' ' + x.lastName,
          value: x.UseName,
        };
      }),
      grid: 3,
    },
  };
  if (role === 'Agent' || role === 'Manager') delete object['authorCPCode'];
  return (
    <DataList
      formPath={paths.newSafety.path}
      filterFields={object}
      columns={[
        {
          label: 'ID',
          dataKey: 'reportId',
          renderColumn: (report: any) => (
            <Badge
              color="secondary"
              variant="dot"
              invisible={!report?.fieldReportsDto?.getResponse}
            >
              {report.reportId}
            </Badge>
          ),
        },
        {
          label: 'Circulation',
          dataKey: 'circulationDateFormat',
        },
        {
          label: 'Train',
          dataKey: 'serviceName',
        },
        {
          label: 'Agent',
          dataKey: 'agent',
        },
        {
          label: 'Residence',
          dataKey: 'agentResidence',
        },
        {
          label: 'Statut',
          dataKey: 'reportStatus',
        },
      ]}
    />
  );
};

export default SafetyList;
